<template>
  <div>
    <h2>Pro-D</h2>
    <v-form id="js-pro-d-form" ref="proDForm">
      <v-container>
        <v-row>
          <p>All entries will be created as NOT VISIBLE to mentees.</p>
        </v-row>
        <v-row>
          <p>Make all entries Visible or Invisible at once here:</p>
          <v-btn
            id="js-set-visibility-true"
            small
            color="secondary"
            class="mx-2"
            @click="updateAllProDVisibility(true)"
            >Make All Visible</v-btn
          >
          <v-btn
            id="js-set-visibility-false"
            small
            color="secondary"
            class="mx-2"
            @click="updateAllProDVisibility(false)"
            >Make All Hidden</v-btn
          >
        </v-row>
        <v-row>
          <v-col>
            <v-combobox
              class="js-area-name"
              v-model="areaName"
              :items="proDAreas"
              label="Area Name"
              :rules="proDAreaRules"
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-combobox
              id="js-pro-d-mission"
              v-model="mission"
              :items="proDNumbers"
              label="mission"
              :rules="proDNumberRules"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              id="js-pro-d-competency"
              v-model="competency"
              :items="proDNumbers"
              label="competency"
              :rules="proDNumberRules"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              id="js-pro-d-style"
              v-model="style"
              :items="proDNumbers"
              label="style"
              :rules="proDNumberRules"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              id="js-pro-d-rank"
              v-model="rank"
              :items="proDNumbers"
              label="rank"
              :rules="proDNumberRules"
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-btn
            class="ma-4"
            id="js-add-pro-d-button"
            color="secondary"
            @click="updateProD()"
            large
          >
            Add Pro-D Results Data
          </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  props: {
    userId: { type: Number }
  },
  data: function() {
    return {
      proDNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      proDAreas: [
        "1_societal_change",
        "2_theoretical_discovery",
        "3_strategic_decisions",
        "4_human_development",
        "5_entrepreneurial_challenge",
        "6_production_efficiency",
        "7_artistic_creativity",
        "8_natural_appreciation",
        "9_motivational_energy"
      ],
      proDNumberRules: [
        v => this.proDNumbers.includes(v) || "Numbers from list only"
      ],
      proDAreaRules: [
        v => this.proDAreas.includes(v) || "Predefined areas only"
      ],
      style: null,
      mission: null,
      competency: null,
      areaName: "",
      rank: null
    }
  },
  methods: {
    updateAllProDVisibility(visible) {
      this.fireEvent("pro_d_result:visibility", {
        visible: visible,
        userId: this.userId
      })
    },
    updateProD() {
      if (this.$refs.proDForm.validate()) {
        this.fireEvent("pro_d_result:add", {
          userId: this.userId,
          name: this.areaName,
          mission: this.mission,
          competency: this.competency,
          style: this.style,
          rank: this.rank,
          visible: false
        })
      } else {
        console.log("not updating because form did not validate")
      }
    }
  }
}
</script>
